<template>
  <v-app>
    <v-container fluid fill-height>
      <v-layout row wrap align-center justify-center>

        <v-flex xs12 sm4 md4>
          <v-flex>
            <v-card-actions style="margin-bottom: -20px;">  
              <v-spacer></v-spacer>
                <v-avatar
                  color="grey lighten-4"
                >
                <img style="height: 10%; width: 220px;" src="@/assets/horizontalLogo.png" alt="avatar">
              </v-avatar>
              <v-spacer></v-spacer>
            </v-card-actions>
            
            <v-card-actions style="margin-top: -20px;">
              <v-spacer></v-spacer>  
                <h3 class="primary--text font-weight-light text-muted"> All in One Business Platform</h3>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-flex>    
        <v-card>  
          <v-card-title primary-title class="primary white--text headline">
            LogIn
          </v-card-title>
          <v-card-text>
          <v-form v-model="isValid">
            <v-text-field
              prepend-icon="person"
              name="email"
              label="Email"
              id="email"
              type="email"
              v-model="email"
              :rules="emailRules"
              required>
            </v-text-field>
            <v-text-field
              prepend-icon="lock"
              name="password"
              label="Password"
              id="password"
              :append-icon="show1 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="show1 = !show1"
              :type="show1 ? 'text' : 'password'"
              v-model="password"
              :rules="passwordRules"
              required>
            </v-text-field>
          </v-form>
        </v-card-text>
  
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn round large primary-title 
              :disabled="!isValid" 
              class="primary white--text" 
              type="submit" 
              @click="signIn">
              Sign In <v-icon right dark>cloud_done</v-icon> 
            </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn round large href="/signup"  primary-title class="blue-grey white--text" type="submit">
              New User ? Create an Account <v-icon right dark>cloud_upload</v-icon> 
            </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions> -->

        <v-card-actions>
          <v-btn  href="/privacy-policy"  text>
            Privacy Policy
          </v-btn> 
          <v-spacer/>
          <v-btn small outline class="primary--text" href="/forgot-password">Forgot password?</v-btn>
        </v-card-actions>
      </v-card>  
    </v-flex>
  </v-layout>
  </v-container>
  <v-snackbar :timeout="timeout" top v-model="snackbar">
    {{message}}
  </v-snackbar>
  </v-app>
</template>
<script>
import { cfirebase } from '../../services/firebase.js'
import { createNamespacedHelpers } from 'vuex'

// const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
const mapGlobalActions = createNamespacedHelpers('Global')['mapActions']

export default {
  data () {
    return {
      message: null,
      isValid: true,
      snackbar: false,
      show1 : false,
      timeout: 1000,
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      password: '',
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be Greater or equal to than 8 characters'
      ],
    }
      checkbox: false
  },
  created () {
    this.$bindAsArray(
      'operators',
      this.$root.$firebaseRefs.operator
    )
    this.$bindAsObject(
      'brands',
      this.$root.$firebaseRefs.brand
    )
  },
  methods: {
    ...mapGlobalActions('SET_SELECTED_BRAND', 'SET_BRANDS'),
    isVerified () {
      if (!this.password || !this.email) {
        this.message = 'Wrong Input'
        return false
      }
      return true
    },
    signIn () {
      if (!this.isVerified()) {
        this.snackbar = true
        return
      }
      cfirebase.auth().setPersistence(cfirebase.auth.Auth.Persistence.LOCAL).then(() => {
        return cfirebase.auth().signInWithEmailAndPassword(this.email, this.password)
          .then((userData) => {
            this.onSignedIn(userData)
            return userData
          })
          .catch((error) => {
            this.message = error.message
            this.snackbar = true
          })
      })
        .catch((error) => {
          this.message = error.message
          this.snackbar = true
        })
    },
    onSignedIn (userData) {
      // Set the token and brand details in localstorage
      // let uid = userData.user.uid
      // console.log(userData)
      // // Object.keys(this.operators).filter
      // const userDetail = this.operators.filter((item) => {
      //   return item.uid === uid
      // })

      // console.log(userDetail)

      // if (!userDetail.length) {
      //   this.message = 'No Brands Assigned'
      //   this.snackbar = true
      //   cfirebase.auth().signOut()
      // }

      // if (userDetail[0].brands.length) {
      //   this.SET_BRANDS(this.brands)
      //   this.SET_SELECTED_BRAND(this.userDetail.brands[0])
      // } else {
      //   this.message = 'No Brands Assigned'
      //   this.snackbar = true
      //   cfirebase.auth().signOut()
      //   return
      // }
      let uid = userData.user.uid;
      // let ref = cfirebase.database().ref('/operators')
      // ref.orderByChild("uid").equalTo(uid).on("value",(snapshot)=>{        
      //     console.log(snapshot.val());
      // })
      
      if(cfirebase.auth().currentUser.emailVerified) {
        const userDetail = this.operators.filter((item) => {
          return item.uid === uid
        })[0];
        cfirebase.auth().onAuthStateChanged((user) => {
        if (user) {
              user.updateProfile({
                displayName: userDetail.brand,
              }).then(function() {
                console.log(success)
              }, function(error) {
                console.log(error)
              });
          }
        })
        if(userDetail.isActive != undefined && userDetail.isActive == false) {
          this.message = 'Your account is not active.'
          cfirebase.auth().signOut()
          this.snackbar = true
        } else {
          this.message = 'Sign In Successful'
          this.snackbar = true
          // this.$router.go('/')
          this.$router.go('/')
        }
      } else {
        
        if(confirm("Your Email is not verified. Do you want to receive verification mail again?")) {
          cfirebase.auth().currentUser.sendEmailVerification();
          this.message = 'Verification Email sent.'
        } else {
          this.message = 'Please verify your Email.'
        }
        cfirebase.auth().signOut()
        this.snackbar = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login/index.vue